import { Obj_Db_Property } from '../models/datapoint/obj_db_property';
import { ObjectWrapper } from '../wrappers/object.wrapper';

export class Obj_Db_PropertiesUtil {
    private static instance: Obj_Db_PropertiesUtil;

    static getInstance(): Obj_Db_PropertiesUtil {
        if (!Obj_Db_PropertiesUtil.instance) {
            Obj_Db_PropertiesUtil.instance = new Obj_Db_PropertiesUtil();
        }

        return Obj_Db_PropertiesUtil.instance;
    }

    /**
    * Obj_Db_PropertiesUtil is a singleton class, so use Obj_Db_PropertiesUtil.getInstance() method instead of creating new Obj_Db_PropertiesUtil().
    */
    private constructor() {

    }

    revertAllObj_Db_Properties(oldObj_Db_Properties: Array<Obj_Db_Property>, newObj_Db_Properties: Array<Obj_Db_Property>, objectWrapper: ObjectWrapper, type: string): void {
        if (type == 'R') {
            if (objectWrapper.object.sel_Run_PropertyType_Cd == 'ALL') {
                oldObj_Db_Properties.splice(0, oldObj_Db_Properties.length);
            } else {
                for (let i: number = 0; i < oldObj_Db_Properties.length; i++) {
                    let Obj_Db_Property = oldObj_Db_Properties[i];
                    if (objectWrapper.object.sel_Run_PropertyType_Cd != Obj_Db_Property.propertyType_Cd) continue;

                    oldObj_Db_Properties.splice(i, 1);
                    i--;
                }
            }

            for (let i: number = 0; i < newObj_Db_Properties.length; i++) {
                oldObj_Db_Properties.push(Obj_Db_Property.parse(newObj_Db_Properties[i]));
            }
        } else {
            let obj_db_propertiesHMap: Map<string, Obj_Db_Property> = new Map<string, Obj_Db_Property>();
            for (let i: number = 0; i < oldObj_Db_Properties.length; i++) {
                let obj_Db_PropertyTmp = oldObj_Db_Properties[i];
                let propertyKey = this.getObj_Db_PropertyKey(obj_Db_PropertyTmp);
                obj_db_propertiesHMap.set(propertyKey, oldObj_Db_Properties[i]);
            }

            for (let i: number = 0; i < newObj_Db_Properties.length; i++) {
                let new_Obj_Db_Property = newObj_Db_Properties[i];
                let propertyKey = this.getObj_Db_PropertyKey(new_Obj_Db_Property);
                let map_Obj_Db_Property = obj_db_propertiesHMap.get(propertyKey);
                if (map_Obj_Db_Property) {
                    map_Obj_Db_Property.propertyVal = new_Obj_Db_Property.propertyVal;
                    map_Obj_Db_Property.overrideFlg = new_Obj_Db_Property.overrideFlg;
                    continue;
                }
                else {
                    oldObj_Db_Properties.push(Obj_Db_Property.parse(new_Obj_Db_Property));
                }
            }
        }
        objectWrapper.doValidate();
    }

    getObj_Db_PropertyKey(obj_Db_Property: Obj_Db_Property): string {
        return obj_Db_Property.conn_Id + '-' +
            obj_Db_Property.dbTyp_Id + '-' +
            obj_Db_Property.el_Type + '-' +
            obj_Db_Property.property_Cd + '-' +
            obj_Db_Property.propertyType_Cd + '-' +
            obj_Db_Property.obj_Id + '-' +
            obj_Db_Property.dxMp_Inst_Id + '-' +
            obj_Db_Property.dxFlow_Id + '-' +
            obj_Db_Property.srt_Order;
    }

    getSearchTermObj_Db_PropertyKey(obj_Db_Property: Obj_Db_Property): string {
        return obj_Db_Property.conn_Id + '-' +
            obj_Db_Property.dbTyp_Id + '-' +
            obj_Db_Property.el_Type + '-' +
            obj_Db_Property.propertyType_Cd + '-' +
            obj_Db_Property.obj_Id + '-' +
            obj_Db_Property.dxMp_Inst_Id + '-' +
            obj_Db_Property.dxFlow_Id + '-' +
            obj_Db_Property.srt_Order;
    }


    getDXMPIObj_Db_PropertyKey(property) {
        return property.dbTyp_Id + '-' +
            property.el_Type + '-' +
            property.property_Cd + '-' +
            property.propertyType_Cd + '-' +
            property.dxMp_Inst_Id + '-' +
            property.dxFlow_Id + '-' +
            property.srt_Order;
    }

    getObj_Db_Property(obj_Db_properties: Array<Obj_Db_Property>, property_Cd: string): Obj_Db_Property {
        for (let i: number = 0; i < obj_Db_properties.length; i++) {
            let _objDbProperty = obj_Db_properties[i];
            if (_objDbProperty.property_Cd != property_Cd) continue;
            return _objDbProperty;
        }

        return null;
    }

    getPropertyVal(obj_Db_properties: Array<Obj_Db_Property>, property_Cd: string): string {
        let obj_Db_Property: Obj_Db_Property = this.getObj_Db_Property(obj_Db_properties, property_Cd);
        if (obj_Db_Property) {
            return obj_Db_Property.propertyVal;
        }

        return "";
    }

    isDisableFilterColumn(obj_Db_properties: Array<Obj_Db_Property>): boolean {
        let sourceDataFormatObj_Db_Property: Obj_Db_Property = this.getObj_Db_Property(obj_Db_properties, 'SOURCE_DATA_FORMAT');
        let sourceIncludeSchemaObj_Db_Property: Obj_Db_Property = this.getObj_Db_Property(obj_Db_properties, 'SOURCE_INCLUDE_SCHEMA_IN_DATA');
        if (sourceDataFormatObj_Db_Property && sourceIncludeSchemaObj_Db_Property) {
            if (sourceDataFormatObj_Db_Property.propertyVal == 'JSON' && sourceIncludeSchemaObj_Db_Property.propertyVal == 'No') {
                return true;
            }
        }

        return false;
    }

    copyObj_Db_Properties(obj_Db_Properties: Array<Obj_Db_Property>, obj_Db_PropertiesCopy: Array<Obj_Db_Property>): void {

        if (obj_Db_PropertiesCopy.length == 0) {
            obj_Db_Properties.splice(0, obj_Db_Properties.length);
            return;
        }

        let obj_Db_PropertiesHMap: Map<string, Obj_Db_Property> = new Map<string, Obj_Db_Property>();

        for (let i = 0; i < obj_Db_Properties.length; i++) {
            let obj_Db_Property = obj_Db_Properties[i];
            let key = this.getObj_Db_PropertyKey(obj_Db_Property);
            obj_Db_PropertiesHMap.set(key, obj_Db_Property);
        }

        obj_Db_Properties.splice(0, obj_Db_Properties.length);

        let obj_Db_PropertiesTmp: Array<Obj_Db_Property> = new Array<Obj_Db_Property>();

        for (let i = 0; i < obj_Db_PropertiesCopy.length; i++) {
            let obj_Db_PropertyCopy = obj_Db_PropertiesCopy[i];

            let key = this.getObj_Db_PropertyKey(obj_Db_PropertyCopy);
            let obj_Db_Property = obj_Db_PropertiesHMap.get(key);
            if (obj_Db_Property) {
                obj_Db_Property.copyFrom(obj_Db_PropertyCopy);
                obj_Db_PropertiesTmp.push(obj_Db_Property);
                continue;
            }

            obj_Db_PropertiesTmp.push(obj_Db_PropertyCopy);
        }

        obj_Db_Properties.push.apply(obj_Db_Properties, obj_Db_PropertiesTmp);
    }

    setShowOn(obj_Db_Properties: Array<Obj_Db_Property>, allProperties: boolean, propertyType_Cd: string): void {
        let showOnProperty_Cds: Array<string> = new Array<string>();
        let obj_Db_Property: Obj_Db_Property;

        for (let i: number = 0; i < obj_Db_Properties.length; i++) {
            obj_Db_Property = obj_Db_Properties[i];
            if (obj_Db_Property.propertyType_Cd != propertyType_Cd) {
                continue;
            }

            if (!allProperties &&
                propertyType_Cd != "" &&
                propertyType_Cd != 'ALL') {
                if (obj_Db_Property.propertyType_Cd != propertyType_Cd) {
                    continue;
                }

                if (!obj_Db_Property.showOn) {
                    continue;
                }
            }

            let showOnProperties: Array<string> = obj_Db_Property.showOnProperties[obj_Db_Property.propertyVal];
            if (!showOnProperties ||
                showOnProperties.length == 0) {
                continue;
            }

            for (let j: number = 0; j < showOnProperties.length; j++) {
                if (showOnProperty_Cds.indexOf(showOnProperties[j]) == -1) {
                    showOnProperty_Cds.push(showOnProperties[j]);
                }
            }
        }

        let showOnPropertyValueCds: Array<string> = new Array<string>();
        for (let i: number = 0; i < obj_Db_Properties.length; i++) {
            obj_Db_Property = obj_Db_Properties[i];

            let showOnProperty_Values: Array<string> = obj_Db_Property.showOnProperty_Values[obj_Db_Property.propertyVal];
            if (!showOnProperty_Values ||
                showOnProperty_Values.length == 0) {
                continue;
            }

            for (let j: number = 0; j < showOnProperty_Values.length; j++) {
                let showOnProperty_Value = showOnProperty_Values[j];
                if (showOnProperty_Value.indexOf('=') != -1) {
                    let splitShowOnProperty_Value = showOnProperty_Value.split('=');
                    showOnPropertyValueCds[splitShowOnProperty_Value[0]] = splitShowOnProperty_Value[1].split(';');
                }
            }
        }

        for (let i: number = 0; i < obj_Db_Properties.length; i++) {
            obj_Db_Property = obj_Db_Properties[i];

            if (!obj_Db_Property.hasRules ||
                obj_Db_Property.hasRules == "0") {
                obj_Db_Property.showOn = true;
            } else if (obj_Db_Property.hasRules == "1") {
                if (showOnProperty_Cds.indexOf(obj_Db_Property.property_Cd) == -1) {
                    obj_Db_Property.showOn = false;
                } else {
                    obj_Db_Property.showOn = true;
                }
            } else if (obj_Db_Property.hasRules == '2') {

            }
        }
    }

    copy(obj_Db_Properties: Array<Obj_Db_Property>): Array<Obj_Db_Property> {
        let obj_Db_PropertiesTmp: Array<Obj_Db_Property> = new Array<Obj_Db_Property>();

        for (let i: number = 0; i < obj_Db_Properties.length; i++) {
            obj_Db_PropertiesTmp.push(Obj_Db_Property.parse(obj_Db_Properties[i]));
        }

        return obj_Db_PropertiesTmp;
    }

    copyFrom(obj_Db_Properties: Array<Obj_Db_Property>, obj_Db_PropertiesTmp: Array<Obj_Db_Property>): void {
        if (obj_Db_PropertiesTmp.length == 0) {
            obj_Db_Properties.splice(0, obj_Db_Properties.length);
            return;
        }

        let obj_Db_PropertiesMap: Map<string, Obj_Db_Property> = new Map();

        let obj_Db_PropertiesLength: number = obj_Db_Properties.length;
        for (let i: number = 0; i < obj_Db_PropertiesLength; i++) {
            let key: string = this.getObj_Db_PropertyKey(obj_Db_Properties[i]);
            obj_Db_PropertiesMap.set(key, obj_Db_Properties[i]);
        }
        obj_Db_Properties.splice(0, obj_Db_Properties.length);

        let obj_Db_PropertiesTmpLength: number = obj_Db_PropertiesTmp.length;
        for (let i: number = 0; i < obj_Db_PropertiesTmpLength; i++) {
            let obj_Db_PropertyTmp: Obj_Db_Property = obj_Db_PropertiesTmp[i];

            let key: string = this.getObj_Db_PropertyKey(obj_Db_PropertyTmp);
            let obj_Db_Property: Obj_Db_Property = obj_Db_PropertiesMap.get(key);
            if (obj_Db_Property) {
                obj_Db_Property.copyFrom(obj_Db_PropertyTmp);
            } else {
                obj_Db_Property = Obj_Db_Property.parse(obj_Db_PropertyTmp);
            }

            obj_Db_Properties.push(obj_Db_Property);
        }
    }

    compare(obj_Db_Properties: Array<Obj_Db_Property>, obj_Db_PropertiesTmp: Array<Obj_Db_Property>): string {
        let obj_Db_PropertiesLength = obj_Db_Properties.length;
        let obj_Db_PropertiesTmpLength = obj_Db_PropertiesTmp.length;

        if (obj_Db_PropertiesLength != obj_Db_PropertiesTmpLength) {
            return 'Obj_Db_Properties length is different.';
        }

        let obj_Db_PropertiesMap: Map<string, Obj_Db_Property> = new Map();
        for (let i: number = 0; i < obj_Db_PropertiesTmp.length; i++) {
            let key: string = this.getObj_Db_PropertyKey(obj_Db_PropertiesTmp[i]);
            obj_Db_PropertiesMap.set(key, obj_Db_PropertiesTmp[i]);
        }

        for (let j: number = 0; j < obj_Db_PropertiesLength; j++) {
            let obj_Db_Property: Obj_Db_Property = obj_Db_Properties[j];
            let key: string = this.getObj_Db_PropertyKey(obj_Db_Properties[j]);
            let obj_Db_PropertyTmp: Obj_Db_Property = obj_Db_PropertiesMap.get(key);
            if (!obj_Db_PropertyTmp) {
                return 'Property Not Found';
            }

            if (obj_Db_Property.compare(obj_Db_PropertyTmp) != '') {
                return 'obj_Db_Properties [' + j + '] is not equal.'
            }
        }

        return '';
    }

    compareSearchTerm(obj_Db_Properties: Array<Obj_Db_Property>, obj_Db_PropertiesTmp: Array<Obj_Db_Property>): string {
        let obj_Db_PropertiesLength = obj_Db_Properties.length;
        let obj_Db_PropertiesTmpLength = obj_Db_PropertiesTmp.length;

        if (obj_Db_PropertiesLength != obj_Db_PropertiesTmpLength) {
            return 'Obj_Db_Properties length is different.';
        }

        let obj_Db_PropertiesMap: Map<string, Obj_Db_Property> = new Map();
        for (let i: number = 0; i < obj_Db_PropertiesTmp.length; i++) {
            let key: string = this.getSearchTermObj_Db_PropertyKey(obj_Db_PropertiesTmp[i]);
            obj_Db_PropertiesMap.set(key, obj_Db_PropertiesTmp[i]);
        }

        for (let j: number = 0; j < obj_Db_PropertiesLength; j++) {
            let obj_Db_Property: Obj_Db_Property = obj_Db_Properties[j];
            let key: string = this.getSearchTermObj_Db_PropertyKey(obj_Db_Properties[j]);
            let obj_Db_PropertyTmp: Obj_Db_Property = obj_Db_PropertiesMap.get(key);

            if (obj_Db_Property.compare(obj_Db_PropertyTmp) != '') {
                return 'obj_Db_Properties [' + j + '] is not equal.'
            }
        }

        return '';
    }

    fillObj_Db_PropertyValues(obj_Db_Properties: Array<Obj_Db_Property>, dxFlow_Id: number, dxMp_Inst_Id: number, obj_Id: number, conn_Id: number): Array<Obj_Db_Property> {
        if (obj_Db_Properties.length == 0) return obj_Db_Properties;

        let obj_Db_PropertiesTmp: Array<Obj_Db_Property> = new Array<Obj_Db_Property>();

        for (let i = 0; i < obj_Db_Properties.length; i++) {
            let obj_Db_Property = obj_Db_Properties[i];

            obj_Db_Property.dxFlow_Id = dxFlow_Id;
            obj_Db_Property.dxMp_Inst_Id = dxMp_Inst_Id;
            obj_Db_Property.obj_Id = obj_Id;
            obj_Db_Property.conn_Id = conn_Id;
            obj_Db_PropertiesTmp.push(Obj_Db_Property.parse(obj_Db_Property));
        }

        return obj_Db_PropertiesTmp;
    }

    toString(obj_Db_Properties: Array<Obj_Db_Property>, isNotCompare: boolean = true): string {
        let str: string = '';

        str += 'Obj_Db_Properties length: ' + obj_Db_Properties.length + ' ';

        for (let i: number = 0; i < obj_Db_Properties.length; i++) {
            str += obj_Db_Properties[i].toString(isNotCompare);
        }

        return str;
    }

}